import React, { useState, forwardRef, useEffect } from "react";
import "../../pages/distributerMaster/distributerMaster.scss";
import "react-datepicker/dist/react-datepicker.css";
import CompanyDocuments from "./CompanyDocuments";
import AdditionalContact from "./AdditionalContact";
import FetchData from "../../providers/dataProvider";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";
import { DropDownComponent } from "../../dropdown/DropDownComponent";
import { PhoneNumberComponent } from "../../dropdown/PhoneNumberComponent";

const style = {
  control: (base) => ({
    ...base,
    boxShadow: "none",
    border: "1px solid #B4BABF",
    backgroundColor: "#F9FBFC",
    fontSize: "14px",
    minHeight: "35px",
    height: "35px",
    borderRadius: "6px",
    color: "#000000",
    whiteSpace: "nowrap",
  }),
};

const GeneralDistributerModal = ({
  HandleFormChange,
  errors,
  values,
  HandleFileChange,
  handleDocumentChange,
  setValues,
  setErrors,
  HandleSubmit,
  countryList,
  distributorTypeList,
  currencyList,
  companyList,
  handleCountryChange,
  handleCurrencyChange,
  handleTypeChange,
  handleDesignationChange,
  removeAttachedFile,
  handleDeleteFile,
  handleAttachmentDate,
  country,
  currency,
  type,
  designation,
  company,
  setCompany,
  setCurrency,
  setType,
  setDesignation,
  setCountry,
  handleRedirect,
  docError,
  setDocError,
  loading,
  handleStatusChange,
  HandleDragOver,
  HandleDrop,
  authPerson,
  setAuthPerson,
  assignedEngineer,
  setAssignedEngineer
}) => {

  const [assignedEngineerData, setAssignedEngineerData] = useState([]);
  const [authorizedPersonData, setAuthorizedPersonData] = useState([]);
  const [conversionDisabled, setConversionDisabled] = useState(false);

  const { data: designationList } = FetchData("designation");
  const { data: documentList } = FetchData("distributorDocuments");
  const { data: departmentList } = FetchData("department");
  const { data: assignedEngineerList } = FetchData("userprofile");

  useEffect(() => {
    const isQAR = currencyList?.some(item => item?.id === values?.currencyId && item?.shortCode === "QAR");
    setValues(prev => ({ ...prev, conversionRate: isQAR ? 1 : "" }));
    setConversionDisabled(isQAR);
  }, [values?.currencyId, currencyList]);

  useEffect(() => {
    setAuthorizedPersonData(assignedEngineerList?.filter(item => (item?.isActive === true || item?.identityId === values?.authorizedPerson)))
  }, [assignedEngineerList, values?.authorizedPerson])

  useEffect(() => {
    if (assignedEngineerList?.length > 0)
      setAssignedEngineerData(assignedEngineerList?.filter(item => item?.userCompanyId === values?.companyId && (item?.isActive === true || item?.identityId === values?.assignedEngineerId)))
  }, [values?.companyId, assignedEngineerList])

  const handleUserAuthorizationChange = (selectedOption) => {
    const selectedAuthPerson = assignedEngineerList?.find(item => item?.identityId === selectedOption?.value)
    setValues({ ...values, authorizedPerson: selectedOption?.value, designationId: selectedAuthPerson?.designationId });
    setErrors((prev) => {
      const next = { ...prev };
      delete next.authorizedPerson;
      delete next.designation;
      return next;
    });
  };

  const handleCompanyChange = (selectedOption) => {
    setValues({ ...values, companyId: selectedOption?.value, assignedEngineerId: "" });
    setErrors((prev) => {
      const next = { ...prev };
      delete next.companyName;
      delete next.assignedEngineer;
      return next;
    });
  };

  const handleAssignedEngineerChange = (selectedOption) => {
    setAssignedEngineer(selectedOption);
    setValues({
      ...values,
      assignedEngineerId: selectedOption?.value,
    });
  };

  useEffect(() => {
    if (documentList?.length > 0) {
      if (values?.id) {
        const docs = documentList.map((docx) => {
          const docc = values?.distributorDocument?.find(
            (obj) => obj?.attachmentId == docx?.id
          );
          if (docc) {
            const d1 = docc?.expDate != null ? new Date(docc?.expDate) : null;
            return {
              ...docx,
              fileName: docc?.docuUrl,
              fileObj: null,
              file: {
                attachmentId: docx?.id,
                docuUrl: docc?.docuUrl,
                expDate: d1,
                isActive: docx?.isActive,
              },
            };
          } else {
            return {
              ...docx,
              fileName: "",
              fileObj: null,
              file: {
                attachmentId: docx?.id,
                docuUrl: "",
                expDate: null,
                isActive: docx?.isActive,
              },
            };
          }
        });
        setValues({
          ...values,
          docs: docs,
        });
      } else {
        const docs = documentList.map((docx) => ({
          ...docx,
          fileName: "",
          fileObj: null,
          file: {
            attachmentId: docx?.id,
            docuUrl: "",
            expDate: null,
            isActive: docx?.isActive,
          },
        }));
        setValues({
          ...values,
          docs: docs,
        });
      }
    }
  }, [documentList, values?.id]);

  return (
    <>

      <div class="card header-card">
        <div className="card-body">
          <div className="row">
            <div className="col-12">
              <div className="card general-info-card mb-2">
                <div className="card-header">
                  <h2>General Information</h2>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div>
                        <label>
                          Distributor Name <span className="mandatory">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="distributorName"
                          placeholder={PlaceHolder?.DISTRIBUTOR_NAME}
                          onChange={HandleFormChange}
                          value={values?.distributorName}
                        ></input>
                        {errors.distributorName && (
                          <p className="form-error">{errors.distributorName}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-2">
                      <div>
                        <label>
                          Distributor Type <span className="mandatory">*</span>
                        </label>
                        <DropDownComponent
                          placeHolder={PlaceHolder?.SELECT_DISTRIBUTOR_TYPE}
                          pageName="distributor"
                          dpDownName="distributorTypesdrp"
                          stateData={distributorTypeList}
                          controlName="distributorType"
                          handleChange={handleTypeChange}
                          value={type}
                          valueId={values?.type}
                          setState={setType}
                          checkLabel={true}
                        />
                        {errors.type && <p className="form-error">{errors.type}</p>}
                      </div>
                    </div>
                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-2">
                      <div>
                        <label>
                          Country <span className="mandatory">*</span>
                        </label>
                        <DropDownComponent
                          placeHolder={PlaceHolder.SELECT_COUNTRY}
                          pageName="project"
                          dpDownName="country"
                          stateData={countryList}
                          controlName="countrydrp"
                          handleChange={handleCountryChange}
                          value={country}
                          valueId={values?.countryId}
                          setState={setCountry}
                        />
                        {errors.country && (
                          <p className="form-error">{errors.country}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                      <div>
                        <label>
                          Website
                        </label>
                        <input
                          className="form-control"
                          type="url"
                          name="website"
                          placeholder={PlaceHolder?.WEB_SITE}
                          onChange={HandleFormChange}
                          value={values?.website}
                        ></input>
                        {errors.website && (
                          <p className="form-error">{errors.website}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                      <div>
                        <label>
                          Email Address <span className="mandatory">*</span>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="email"
                          placeholder={PlaceHolder?.EMAIL_ADDRESS}
                          onChange={HandleFormChange}
                          value={values?.email}
                        ></input>
                        {errors?.email && <p className="form-error">{errors?.email}</p>}
                      </div>
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                      <div>
                        <label>
                          Authorized Person <span className="mandatory">*</span>
                        </label>
                        <DropDownComponent
                          placeHolder={PlaceHolder.SELECT_AUTHORIZED_PERSON}
                          pageName="distributor"
                          dpDownName="salesengineer"
                          stateData={authorizedPersonData}
                          controlName="authorizedPerson"
                          handleChange={(e) => { handleUserAuthorizationChange(e) }}
                          value={authPerson}
                          valueId={values?.authorizedPerson}
                          setState={setAuthPerson}
                          multiSelect={false}
                        />
                        {errors.authorizedPerson && (
                          <p className="form-error">{errors.authorizedPerson}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                      <div>
                        <label>
                          Position <span className="mandatory">*</span>
                        </label>
                        <DropDownComponent
                          placeHolder={values?.authorizedPerson ? PlaceHolder.SELECT_POSITION : PlaceHolder.MUST_CHOOSE_FIELD("authorized person", "position")}
                          pageName="distributor"
                          dpDownName="designation"
                          controlName="designationId"
                          stateData={designationList}
                          handleChange={handleDesignationChange}
                          value={designation}
                          valueId={values?.designationId}
                          setState={setDesignation}
                          isDisabled={true} />
                        {errors.designation && (
                          <p className="form-error">{errors.designation}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                      <div>
                        <label>
                          Address <span className="mandatory">*</span>
                        </label>
                        <textarea
                          className="form-control address-text-area"
                          placeholder={PlaceHolder?.ADDRESS}
                          rows="5"
                          name="address"
                          onChange={HandleFormChange}
                          value={values?.address}
                        ></textarea>
                        {errors.address && (
                          <p className="form-error">{errors.address}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <div className="row">
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                          <div>
                            <label>
                              Fax Number
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder={PlaceHolder?.FAX}
                              name="fax"
                              onChange={HandleFormChange}
                              value={values?.fax}
                            ></input>
                            {errors.fax && <p className="form-error">{errors.fax}</p>}
                          </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                          <div>
                            <label>
                              Phone Number <span className="mandatory">*</span>
                            </label>
                            <PhoneNumberComponent defaultCountry={country?.code} errors={errors} setValues={setValues} setErrors={setErrors} filedName="phone" values={values} />
                            {errors?.phone && (
                              <p className="form-error">{errors?.phone}</p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                          <div>
                            <label>
                              Currency <span className="mandatory">*</span>{" "}
                            </label>
                            <DropDownComponent
                              isDisabled={false}
                              placeHolder={PlaceHolder.SELECT_CURRENCY}
                              pageName="distributor"
                              dpDownName="currencyCode"
                              stateData={currencyList}
                              controlName="currency"
                              handleChange={handleCurrencyChange}
                              value={currency}
                              valueId={values?.currencyId}
                              setState={setCurrency}
                              multiSelect={false}
                            />
                            {errors.currency && (
                              <p className="form-error">{errors.currency}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                          <div>
                            <label>
                              Conversion rate <span className="mandatory">*</span>
                            </label>
                            <div class="input-group mb-3">
                              <input
                                type="text"
                                class="form-control"
                                placeholder={PlaceHolder?.CONVERSION_RATE}
                                name="conversionRate"
                                onChange={HandleFormChange}
                                value={values?.conversionRate}
                                disabled={conversionDisabled}
                              />
                              <span class="input-group-text" id="basic-addon2">
                                {" "}
                                1 QAR
                              </span>
                            </div>{" "}
                            {errors?.conversionRate && (
                              <p className="form-error">{errors?.conversionRate}</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    {values?.id && (
                      <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-12 col-xs-12 mb-2">
                        <label>Status</label>
                        <div class="form-group">
                          <input
                            type="checkbox"
                            id="isActive"
                            name="isActive"
                            value={values?.isActive}
                            checked={values?.isActive}
                            onChange={(e) => handleStatusChange(e)}
                          />
                          <label for="isActive" className="mb-0">
                            {values?.isActive ? "Active" : "Inactive"}
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="card company-info-card mb-2">
                  <div className="card-header">
                    <h2>Company Information</h2>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                        <div>
                          <label>
                            Company Name <span className="mandatory">*</span>
                          </label>
                          <DropDownComponent
                            placeHolder={PlaceHolder.SELECT_COMPANY}
                            pageName="company"
                            dpDownName="company"
                            stateData={companyList}
                            controlName="companydrp"
                            handleChange={handleCompanyChange}
                            value={company}
                            valueId={values?.companyId}
                            setState={setCompany}
                            multiSelect={false}
                            styles={style}
                          />
                          {errors.companyName && (
                            <p className="form-error">{errors.companyName}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                        <div>
                          <label>
                            Assigned Engineer <span className="mandatory">*</span>
                          </label>
                          <DropDownComponent
                            placeHolder={values?.companyId ? PlaceHolder.SELECT_ENGINEER : PlaceHolder.MUST_CHOOSE_FIELD("company", "assigned engineer")}
                            pageName="distributor"
                            dpDownName="salesengineer"
                            stateData={assignedEngineerData}
                            controlName="assignedEngineer"
                            handleChange={handleAssignedEngineerChange}
                            value={assignedEngineer}
                            valueId={values?.assignedEngineerId}
                            setState={setAssignedEngineer}
                            multiSelect={false}
                            isDisabled={values?.companyId ? false : true}
                          />
                          {errors.assignedEngineer && (
                            <p className="form-error">{errors.assignedEngineer}</p>
                          )}
                        </div>

                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                        <div>
                          <label>Additional info </label>
                          <textarea
                            className="form-control"
                            placeholder={PlaceHolder?.ADDITIONAL_NOTES}
                            rows="5"
                            name="additionalInfo"
                            onChange={HandleFormChange}
                            value={values?.additionalInfo}
                          ></textarea>
                          {errors.additionalInfo && (
                            <p className="form-error">{errors.additionalInfo}</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
                {/* <!-- Company Documents--> */}
              <CompanyDocuments
                DocumentsName="Documents"
                HandleDragOver={HandleDragOver}
                HandleDrop={HandleDrop}
                HandleFileChange={HandleFileChange}
                values={values}
                handleDocumentChange={handleDocumentChange}
                errors={errors}
                setValues={setValues}
                removeAttachedFile={removeAttachedFile}
                handleDeleteFile={handleDeleteFile}
                handleAttachmentDate={handleAttachmentDate}
                docError={docError}
                setErrors={setErrors}
              />
                {/* <!-- Additional Contact--> */}
              <AdditionalContact
                errors={errors}
                setErrors={setErrors}
                values={values}
                setValues={setValues}
                HandleSubmit={HandleSubmit}
                handleRedirect={handleRedirect}
                loading={loading}
                designationList={designationList}
                departmentList={departmentList}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GeneralDistributerModal;
